import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { Book } from "@modules/books/types";
import { BookFormValues } from "@modules/books/validations";


export async function createBookService(data: BookFormValues): Promise<Book> {
  const formatedData = appendFormData(data);
  const headers =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: book } = await api.post<Book>("v1/book_admin/", formatedData, {
    headers,
  });
  return book;
}
